module.exports = __webpack_public_path__ + "img/pic-QuintusSu.a0283247.png";